/*
 *  This document is the CONFIDENTIAL PROPERTY of Corero Network Security, Inc.
 *  Copyright (C) 2024-2025 by Corero Network Security, Inc. All rights reserved.
 *  Notice of copyright on this document does not constitute publication.
 */


const sharedConfig = {
    version: '3.2.1.0017',
    copyrightYear: `2026`,
    apis: {
        changePassword: '/api/users/updatePassword',
        login: '/auth',
        logout: '/auth/log_out',
        ssoWsgi: '/auth/sso',
        tenants: '/api/tenants',
        tokenRefresh: '/refresh',
        userBy: '/api/users/search/findByUsername',
        resetPassword: '/api/login/resetPassword',
        sendPasswordResetEmail: '/api/login/sendPasswordResetEmail',
        validatePasswordResetToken: '/api/login/validatePasswordResetToken',
        theme: '/api/login/theme',
        ssoConfigLogin: '/api/login/sso-config/login-config',
        saml2ConfigLogin: '/api/login/saml2-config/login-config',
    },
    faviconDimensions: {
        D_16X16: 'D_16X16',
        D_32X32: 'D_32X32',
    },
    roles: {
        supportUser: 'ROLE_SUPPORT_USER',
        mspAdmin: 'ROLE_MSP_ADMINISTRATOR',
        mspUser: 'ROLE_MSP_USER',
        tenantAdmin: 'ROLE_TENANT_ADMINISTRATOR',
        tenantUser: 'ROLE_TENANT_USER'
    },
}

export default sharedConfig;
